import config from '../config';
//公共图片路径处理文件
export function forMat() {
  return config.backendUrl;
}

//截取文件名称
export function intercept(url) {
  let originname = url.split('/')[url.split('/').length - 1]; //获取最后‘/’后的带时间戳的文件名
  let filename = originname.slice(13); //从第14位开始截取，去掉13位时间戳
  return filename;
}

// 上传文件地址
export function baseFileUrl() {
  return config.backendUrl + config.baseFileUrl;
}

export function backFront() {
  return config.backFront;
}

// 上传excle
export function uploadExcelUrl() {
  return config.backendUrl + config.uploadExcelUrl;
}
// 登录页观众注册

export function regist() {
  return config.registUrl;
}

//第三方观众预注册
export function otherRegistZh() {
  return config.otherRegistZh;
}

export function otherRegistEn() {
  return config.otherRegistEn;
}

// 获取前端编辑器资源目录
export function editorResourceUrl() {
  return config.tinymceUrl + config.editPrefix;
}

// 线上展会的产品详情页面
export function backProductDetail() {
  return config.backProductDetail;
}

// 线上展会的活动详情页面
export function backActivityDetail() {
  return config.backActivityDetail;
}

// 线上展会的直播详情页面
export function backLiveDetail() {
  return config.backLiveDetail;
}

// 线上展会的展商详情页面
export function backExhibitorDetail() {
  return config.backExhibitorDetail;
}

// 线上展会展商列表页
export function backExhibitionList() {
  return config.backExhibitionList;
}

// 判断浏览器的头是否为移动端
export function perfix() {
  // header 手机特征信息
  if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
    //显示移动端的代码
    return true;
  } else {
    //显示非移动端的代码
    return false;
  }
}
